import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useNavigate } from 'react-router-dom'
import Loading from '../pages/util/Loading'
import { loadUser, logout } from '../redux/actions/userAction'

const PrivateRoute = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {loading} = useSelector(state=>state.user)

    const logoutUser = (route) => {
      dispatch(logout())
      .then(res=>{
        if (res.success) {
          navigate(route)
        }
      })
    }

    useEffect(() => {
      const user = localStorage.getItem("token")
      if (!user) {
        logoutUser("/login")
      }
    }, [])

    return loading ? <Loading/> :  <Outlet />
}

export default PrivateRoute